import { render, staticRenderFns } from "./FilesStep.vue?vue&type=template&id=be94fc2a"
import script from "./FilesStep.vue?vue&type=script&lang=js"
export * from "./FilesStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports